import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import withStyles from "components/with-styles";
import styles from "./styles/loading.css.js";

const Loading = ({ className, classes, message }) => (
  <div className={cn(className, classes.root)}>
    <CircularProgress />
    <Typography variant="body1">{message}</Typography>
  </div>
);

Loading.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,

  /**
   * Mensaje de carga.
   */
  message: PropTypes.node.isRequired,
};

export default withStyles(styles)(Loading);
